/**
 * inputSelectDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function inputSelectDirective() {
    return {
        restrict: 'E',
        transclude: true,
        //language=HTML
        template: `
            <md-input-container>
                <label>{{ label }}</label>

                <md-select name="{{ name }}"
                           aria-label="{{ label }}"
                           md-on-close="_onClose()"
                           md-container-class="app-input-select-menu-container"
                           ng-change="_onChange()"
                           ng-model="value"
                           ng-model-options="ngModelOptions"
                           ng-disabled="disabled"
                           ng-required="required"
                           placeholder="{{ placeholder }}">

                    <ng-transclude></ng-transclude>

                    <md-option class="app-input-select-option"
                               ng-repeat="option in options track by _trackBy(option)"
                               ng-value="option.value"
                               summary="{{ option.summary }}"
                               data-testid="option:{{ _trackBy(option) }}">
                        <div>{{ option.label }}</div>
                        <small ng-if="option.details">{{ option.details }}</small>
                    </md-option>
                </md-select>

                <app-loading ng-if="loading"></app-loading>

                <div class="hint" ng-if="hint">{{ hint }}</div>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>

            <md-button class="md-icon-button app-form-field-clear"
                       ng-if="isClearable"
                       ng-disabled="value === undefined"
                       ng-click="clear()">
                <md-icon>clear</md-icon>
            </md-button>
        `,
        scope: {
            isClearable: '=?clearable',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            hint: '@hint',
            label: '@label',
            loading: '=?loading',
            name: '@name',
            ngModelOptions: '=?ngModelOptions',
            noFloat: '=?noFloat',
            onChange: '&?change',
            trackBy: '=?trackBy',
            options: '=options',
            placeholder: '@?placeholder',
            required: '=?required',
            value: '=value',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');
            element.addClass('app-form-select');

            scope._onChange = _onChange;
            scope._onClose = _onSelectClosed;
            scope._trackBy = _trackBy;
            scope.clear = clear;

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            if (scope.noFloat === undefined && attrs.noFloat !== undefined) {
                scope.noFloat = true;
            }

            scope.$watch('isClearable', value => {
                if (value) {
                    element.addClass('app-form-select--clearable');
                } else {
                    element.removeClass('app-form-select--clearable');
                }
            });

            function _onChange() {
                if (angular.isFunction(scope.onChange)) {
                    scope.onChange();
                }

                if (!scope.form || !scope.name) {
                    return;
                }

                if (scope.value && scope.form && scope.form[scope.name]) {
                    scope.form[scope.name].$setValidity('custom', true);
                    scope.form[scope.name].customError = null;
                }
            }

            function _onSelectClosed() {
                const hasValue = !!scope.value;

                hasValue ? element.addClass('filled') : element.removeClass('filled');
            }

            function _trackBy(option) {
                if (angular.isFunction(scope.trackBy)) {
                    return scope.trackBy(option);
                }

                return option.value;
            }

            function clear() {
                scope.value = undefined;

                _onChange();
            }
        },
    };
}
